/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host,
* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  display: none;
  position: absolute;
  z-index: 10;
}

:host([show]) {
  display: inline;
}

.modal {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  pointer-events: none;
}
:host([modal]) .modal {
  pointer-events: auto;
}

.modal .overlay {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}
:host([modal]) .modal .overlay {
  background-color: black;
  opacity: 0.1;
  pointer-events: none;
}

.modal .flex {
  position: absolute;
  pointer-events: all;
  background-color: #FFF;
  background-color: var(--davinci-color-background, #FFF);
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
          flex-direction: row;
  flex-wrap: nowrap;
  -webkit-box-pack: start;
          justify-content: flex-start;
  align-content: flex-start;
  -webkit-box-align: start;
          align-items: flex-start;
  margin: 1.071rem;
  max-width: 21.429rem;
  min-width: 3.571rem;
  box-shadow: 0px 6px 6px -3px rgba(0, 0, 0, 0.2), 0px 10px 14px 1px rgba(0, 0, 0, 0.14), 0px 4px 18px 3px rgba(0, 0, 0, 0.12);
}
:host([type=error]) .modal .flex {
  background-color: #EA0823;
  background-color: var(--davinci-color-error, #EA0823);
  color: #FFF;
  color: var(--davinci-color-text-on-error, #FFF);
}

:host([type=warning]) .modal .flex {
  background-color: #F5C413;
  background-color: var(--davinci-color-warning, #F5C413);
  color: #323c49;
  color: var(--davinci-color-text-on-warning, #323c49);
}

:host([type=success]) .modal .flex {
  background-color: #63b017;
  background-color: var(--davinci-color-success, #63b017);
  color: #FFF;
  color: var(--davinci-color-text-on-success, #FFF);
}

.modal .flex .tipShadow {
  box-shadow: 0px 6px 6px -3px rgba(0, 0, 0, 0.2), 0px 10px 14px 1px rgba(0, 0, 0, 0.14), 0px 4px 18px 3px rgba(0, 0, 0, 0.12);
  z-index: -1;
}
.modal .flex .tip {
  position: absolute;
  background-color: #FFF;
  background-color: var(--davinci-color-background, #FFF);
  height: 1.143rem;
  width: 1.143rem;
}
:host([type=error]) .modal .flex .tip {
  background-color: #EA0823;
  background-color: var(--davinci-color-error, #EA0823);
}

:host([type=warning]) .modal .flex .tip {
  background-color: #F5C413;
  background-color: var(--davinci-color-warning, #F5C413);
}

:host([type=success]) .modal .flex .tip {
  background-color: #63b017;
  background-color: var(--davinci-color-success, #63b017);
}

.modal .flex.right .tip {
  left: 0;
  -webkit-transform: translate(-50%, 1.071rem) rotate(45deg);
          transform: translate(-50%, 1.071rem) rotate(45deg);
}
.modal .flex.right.alignbottom .tip {
  left: 0;
  bottom: 0;
  -webkit-transform: translate(-50%, -1.071rem) rotate(45deg);
          transform: translate(-50%, -1.071rem) rotate(45deg);
}
.modal .flex.bottom .tip {
  top: 0;
  -webkit-transform: translate(1.071rem, -50%) rotate(45deg);
          transform: translate(1.071rem, -50%) rotate(45deg);
}
.modal .flex.bottom.alignright .tip {
  top: 0;
  right: 0;
  -webkit-transform: translate(-1.071rem, -50%) rotate(45deg);
          transform: translate(-1.071rem, -50%) rotate(45deg);
}
.modal .flex.top .tip {
  bottom: 0;
  -webkit-transform: translate(1.071rem, 50%) rotate(45deg);
          transform: translate(1.071rem, 50%) rotate(45deg);
}
.modal .flex.top.alignright .tip {
  bottom: 0;
  right: 0;
  -webkit-transform: translate(-1.071rem, 50%) rotate(45deg);
          transform: translate(-1.071rem, 50%) rotate(45deg);
}
.modal .flex.left .tip {
  right: 0;
  -webkit-transform: translate(50%, 1.071rem) rotate(45deg);
          transform: translate(50%, 1.071rem) rotate(45deg);
}
.modal .flex.left.alignbottom .tip {
  right: 0;
  bottom: 0;
  -webkit-transform: translate(50%, -1.071rem) rotate(45deg);
          transform: translate(50%, -1.071rem) rotate(45deg);
}
.modal .flex .slot {
  -webkit-box-ordinal-group: 1;
          order: 0;
  -webkit-box-flex: 1;
          flex: 1 1 auto;
  align-self: auto;
  padding: 1.429rem;
  font-size: 0.857rem;
  background-color: #FFF;
  background-color: var(--davinci-color-background, #FFF);
}
.modal .flex .slot .headline {
  color: #505F6B;
  color: var(--davinci-color-text-light, #505F6B);
  fill: #505F6B;
  fill: var(--davinci-color-text-light, #505F6B);
  font-weight: bold;
  font-size: calc(14rem/14);
  margin-bottom: calc(10rem/14);
}
:host([type=error]) .modal .flex .slot .headline {
  color: #FFF;
  color: var(--davinci-color-text-on-error, #FFF);
  fill: #FFF;
  fill: var(--davinci-color-text-on-error, #FFF);
}

:host([type=warning]) .modal .flex .slot .headline {
  color: #323c49;
  color: var(--davinci-color-text-on-warning, #323c49);
  fill: #323c49;
  fill: var(--davinci-color-text-on-warning, #323c49);
}

:host([type=success]) .modal .flex .slot .headline {
  color: #FFF;
  color: var(--davinci-color-text-on-success, #FFF);
  fill: #FFF;
  fill: var(--davinci-color-text-on-success, #FFF);
}

.modal .flex .slot ::slotted(*) {
  font-size: calc(12rem/14);
  color: #323c43;
  color: var(--davinci-color-text, #323c43);
}
:host([type=error]) .modal .flex .slot {
  background-color: #EA0823;
  background-color: var(--davinci-color-error, #EA0823);
}
:host([type=error]) .modal .flex .slot ::slotted(*) {
  color: #FFF;
  color: var(--davinci-color-text-on-error, #FFF);
}

:host([type=warning]) .modal .flex .slot {
  background-color: #F5C413;
  background-color: var(--davinci-color-warning, #F5C413);
}
:host([type=warning]) .modal .flex .slot ::slotted(*) {
  color: #323c49;
  color: var(--davinci-color-text-on-warning, #323c49);
}

:host([type=success]) .modal .flex .slot {
  background-color: #63b017;
  background-color: var(--davinci-color-success, #63b017);
}
:host([type=success]) .modal .flex .slot ::slotted(*) {
  color: #FFF;
  color: var(--davinci-color-text-on-success, #FFF);
}`;
export { style };
//# sourceMappingURL=Balloon.style.js.map